import { render, staticRenderFns } from "./Credentials.vue?vue&type=template&id=a97cd0c0&"
import script from "./Credentials.vue?vue&type=script&lang=js&"
export * from "./Credentials.vue?vue&type=script&lang=js&"
import style0 from "./Credentials.vue?vue&type=style&index=0&id=a97cd0c0&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports